import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { MaterialModule, } from "jk-service";
import { StkleService, templateUrlConfigStk } from './../_service_stk';
import { Stkle } from './../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkle-edit',
  templateUrl: './stkle-editPkg.component.html',//templateUrlConfigStk.stkle,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})

export class StkleEditComponent extends JkDialogEditComponent<StkleService, Stkle> {
  override dialogRef: MatDialogRef<StkleEditComponent>;
  override data: jkRestReturn;

  override srv!: StkleService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkleEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
